"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapOrderTaskDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const StepTaskDTO_1 = require("./StepTaskDTO");
const OrderResourceDTO_1 = require("./OrderResourceDTO");
const ServiceTaskDTO_1 = require("./ServiceTaskDTO");
const ServiceGroupTaskDTO_1 = require("./ServiceGroupTaskDTO");
const OrderTaskDTO_1 = require("./OrderTaskDTO");
class WrapOrderTaskDTO {
}
exports.WrapOrderTaskDTO = WrapOrderTaskDTO;
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OrderTaskDTO_1.OrderTaskDTO, {
        discriminator: {
            property: 'taskType',
            subTypes: [
                { name: 'resource', value: OrderResourceDTO_1.OrderResourceDTO },
                { name: 'step-task', value: StepTaskDTO_1.StepTaskDTO },
                { name: 'service-task', value: ServiceTaskDTO_1.ServiceTaskDTO },
                { name: 'service-group-task', value: ServiceGroupTaskDTO_1.ServiceGroupTaskDTO }
            ]
        },
        keepDiscriminatorProperty: true
    }),
    __metadata("design:type", Object)
], WrapOrderTaskDTO.prototype, "task", void 0);
